import React from 'react';
import { observer, inject } from 'mobx-react';
import { Panel, Row, Col, } from 'react-bootstrap';
import RoomList from './RoomList';


@inject('roomStore')
@observer
export default class Rooms extends React.Component {

    render() {
        return (<Panel>
            <Panel.Heading>
                   <Row>
                       <Col lg={10} > <h5>Rooms</h5> </Col>
                   </Row>
            </Panel.Heading>
            <Panel.Body>
                <RoomList />
            </Panel.Body>
        </Panel>);
    }
}


// WEBPACK FOOTER //
// ./src/components/Rooms/index.js